<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Presupuestos del cliente</h2></v-toolbar-title></pre>
        </v-toolbar>

        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="presupuestos"
            :search="search"
            :items-per-page="15"
            item-key="id"
            @click:row="
                (item) =>
                    $router.push(
                        `guardar-presupuesto-${
                            $route.meta.rol == 1 ? 'potencial' : 'cliente'
                        }?id=${item.id}`
                    )
            "
            :item-class="
                () => {
                    return 'pointer';
                }
            "
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
            <template v-slot:item.fecha="{ item }">
                <span>{{ item.fecha | format_date }}</span>
            </template>
            <template v-slot:item.cobrado="{ item }">
                <span>{{ item.cobrado | format_precio }} </span>
            </template>
            <template v-slot:item.importe="{ item }">
                <span>{{ item.importe | format_precio }} </span>
            </template>
            <template v-slot:item.pendiente="{ item }">
                <span>{{ (item.importe - item.cobrado) | format_precio }}</span>
            </template>
            <template v-slot:item.pdf="{ item }">
                <a
                    target="_blank"
                    :href="`/api/pdf-presupuesto/${item.id}`"
                    @click.stop=""
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="PDF"
                        >mdi-pdf-box</v-icon
                    >
                </a>
            </template>
            <template v-slot:item.action="{ item }">
                <router-link
                    :to="{
                        path: `/guardar-presupuesto-${
                            $route.meta.rol == 1 ? 'potencial' : 'cliente'
                        }?id=${item.id}`,
                    }"
                    class="action-buttons"
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                </router-link>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
export default {
    props: ["presupuestos"],
    data() {
        return {
            search: "",
            headers: [
                { text: "Nº Presupuesto", value: "id", sortable: false },
                {
                    text: "Fecha de resolución",
                    value: "fecha",
                    sortable: false,
                },
                { text: "Importe", value: "importe", sortable: false },
                { text: "Cobrado", value: "cobrado", sortable: false },
                {
                    text: "Pendiente de cobro",
                    value: "pendiente",
                    sortable: false,
                },

                { text: "PDF", value: "pdf", sortable: false },
            ],

            Clientes: [],
        };
    },
    created() {},
    methods: {},
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
